module.exports = __webpack_public_path__ + "img/4.200d60a4.svg";